import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: true
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], callback: (item: any) => boolean): unknown {
    if (!items || !callback) {
        return items;
    }
    return items.filter(item => callback(item));
  }

}
